import { onDocumentReady } from '../utils/events';
import Splide from '@splidejs/splide';
import { AdjustableHeight } from '../utils/splide-auto-height';

onDocumentReady(() => {
  const sliderEl = document.querySelector('.our-team__members');

  if (sliderEl) {
    const splide = new Splide(sliderEl, {
      type: 'loop',
      perMove: 1,
      perPage: 3,
      gap: '2.5rem',
      drag: true,
      flickPower: 150,
      dragMinThreshold: {
        mouse: 40,
        touch: 70,
      },
      arrows: true,
      pagination: true,
      keyboard: 'focused',
      rewind: true,
      focus: 0,
      breakpoints: {
        1200: {
          perPage: 2,
        },
        1024: {
          gap: '1.25rem',
        },
        768: {
          perPage: 1,
        },
        640: {
          pagination: false,
        },
      },
    });
    splide.mount({ AdjustableHeight });

    const refreshSlider = () => {
      window.requestAnimationFrame(() => {
        splide.refresh();
      });
    };

    if (document.readyState === 'complete') {
      refreshSlider();
    } else {
      window.addEventListener('load', refreshSlider, { once: true });
    }

    if (document.fonts?.ready) {
      document.fonts.ready.then(refreshSlider);
    }
  }
});
